.c2{flex-shrink:0;}